module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_footer_aqua-acdfe930de57297a7d637841deea3a52.svg";